var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.userIds
        ? _c("contact-navbar", {
            staticClass: "mb-1",
            attrs: { search: _vm.filter.search || "" },
            on: {
              search: function ($event) {
                return _vm.onSearchChanged($event)
              },
              "delete-search": function ($event) {
                _vm.filter = {}
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.numContacts > 0
        ? _c("div", [
            _c("small", { staticClass: "text-muted me-1" }, [
              _vm._v(_vm._s(_vm.numContacts) + " Treffer"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-group text-deco-none" },
              _vm._l(_vm.contacts, function (contact) {
                return _c(
                  "router-link",
                  {
                    key: contact.id,
                    staticClass: "text-deco-none",
                    attrs: { to: _vm.contactUrl(contact) },
                  },
                  [_c("contact-entry", { attrs: { contact: contact } })],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _vm.numPages > 1
              ? _c("div", { staticClass: "py-3 text-center" }, [
                  _c("button", { attrs: { disabled: _vm.page == 1 } }, [
                    _c("i", {
                      staticClass: "fas fa-chevron-left",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.previousPage()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mx-3" }, [
                    _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.numPages)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    { attrs: { disabled: _vm.page == _vm.numPages } },
                    [
                      _c("i", {
                        staticClass: "fas fa-chevron-right",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nextPage()
                          },
                        },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _c("div", [
            _c("div", { staticClass: "text-center mt-5" }, [
              _vm._v("-- keine Treffer --"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }